<template>
  <v-container>
    <v-row wrap>
      <v-flex xs2>
        <v-btn
          color="orange"
          text
          large
          @click="$router.push({'name': 'Admin'})"
        >
          Admin Home
        </v-btn>
      </v-flex>
      <v-flex xs8 class="text-center">
        <span class="mr-5 headline pa-2">Manage User Accounts</span>


      </v-flex>
      <v-flex xs2>

      </v-flex>
    </v-row>

    <v-card class="pa-5" outlined flat>
      <div class="title">Manage User Domain Auth</div>
      <v-text-field outlined class="pa-1" label='email' v-model="email"></v-text-field>
      <v-btn @click="loadUser(email)">Load User Data</v-btn>
      <v-card flat outlined class="mt-3 pa-5" v-if="users" v-for="(user, key) in users" :key="key">
        <v-layout row>
          <v-flex xs6 sm4>
            <v-text-field disabled label="First Name" v-model="user.firstname"></v-text-field>
          </v-flex>
          <v-flex xs6 sm4>
            <v-text-field disabled label="Last Name" v-model="user.lastname"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field disabled label="UID" v-model="user.uid"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card flat class="ma-5">
              <div>
                Use this button to verify a users email if they have emailed you from the email address.
              </div>
              <v-combobox
                multiple
                clearable
                label="Tags"
                outlined
                chips
                :items="$store.state.contentProps.domains"
                v-model="user.domainAuth"
                class="mx-2"
                @change="saveUserProp(user, 'domainAuth')"
              ></v-combobox>
              </v-card>
          </v-flex>
          <v-flex xs12 sm6 class="text-center pt-3">
            <v-card flat class="ma-5">
              <div>
                Use this drop down to add domains (such as school domains) if users used personal email addresses.
              </div>
              
              <v-btn
               flat
               rounded
               dark
               color="primary"
                @click="verifyEmail(user.uid)"
                class="mt-3"
                :loading="verifyLoading"
              >Verify Email</v-btn>

            </v-card>

          </v-flex>
          <v-flex xs12 sm6 class="text-center pt-3">
            <v-card flat class="ma-5">
              <div>
                Use this button to generate a password reset link if the user is not getting the reset email. ONLY DO THIS if they email from the actual email address.
              </div>
              
              <v-btn
               flat
               rounded
               dark
               :loading="resetLinkLoading"
               color="primary"
                @click="passwordResetLink(user.email)"
                class="mt-3"
              >Create Link</v-btn>

              <v-card outlined class="pa-5 mt-5" v-if="resetLink">
                {{ resetLink }}
                <div class="text-right">
                  <v-btn rounded  dark primary @click="copyText(resetLink)">Copy Link</v-btn>

                </div>
              </v-card>

              

            </v-card>

          </v-flex>   
        </v-layout>
    </v-card>




    </v-card>


  </v-container>


</template>
<script>
import firebase from 'firebase'
export default {
  name: 'ManageUsers',
  data() {
    return {
      email: null,
      users: null,
      resetLink: null,
      resetLinkLoading: false,
      verifyLoading: false

    }
  },
  mounted() {

  },
  methods: {
    copyText(link) {
      navigator.clipboard.writeText(link)
    },
    passwordResetLink(email) {
      var FBpasswordResetLink = firebase.functions().httpsCallable('passwordResetLink');
      this.resetLinkLoading = true
      FBpasswordResetLink({ email })
        .then((result) => {
          this.resetLink = result.data
          this.resetLinkLoading = false
        }).catch(() => {
          alert("user failed")
          this.resetLinkLoading = false
        })
    },
    loadUser(email) {
      firebase.firestore().collection('users').where('email', '==', this.email).onSnapshot(snapshot => {
        this.users = []
        snapshot.forEach(doc => {
          let data = doc.data()
          data.uid = doc.id
          this.users.push(data)
        })
      })
    },
    saveUserProp(user, prop) {
      let ref = firebase.firestore().collection('users').doc(user.uid)
      let updates = {}
      updates[prop] = user[prop]
      ref.update(updates)
    },
    verifyEmail(uid) {
      console.log('click')
      var verifyEmailManually = firebase.functions().httpsCallable('verifyEmailManually');
      this.verifyLoading = true
      verifyEmailManually({ uid })
        .then(() => {
          this.verifyLoading = false
          alert("Verified")
        }).catch(() => {
          this.verifyLoading = false
          alert("user failed")
        })

    }
  }
}
</script>
